import React from 'react'
import type { Icon } from 'shared/utils'
export const Burger = (props: Icon) => {
    const {
        color = 'black',
        size = 24,
        className = 'burger',
        ...otherProps
    } = props
    return (
        <svg
            width={size}
            height={size}
            fill={color}
            className={className}
            viewBox="0 0 24 24"
            {...otherProps}>
            <g fillRule="nonzero">
                <path d="M17.13 17.44a94.636 94.636 0 00-3.557-.09c-.69 0-1.084.02-1.502.041-.475.026-1.014.054-2.015.054-.85 0-1.944-.02-3.346-.062l-.21-.007c-.78-.02-2.18-.06-3.428-.517a2.222 2.222 0 00-.005.631c.16 1.282 1.037 2.275 2.006 2.725.946.436 1.975.453 2.982.453h.083l7.794-.006c1.112 0 2.265-.01 3.28-.581.917-.518 1.687-1.702 1.735-2.948-.591.175-1.535.32-3.09.32-.288 0-.54-.007-.726-.014l-.001.002zM21.65 11.75c-.292.252-.695.463-1.246.588-.219.05-.552.096-1.507.096a69.75 69.75 0 01-2.885-.079 62.472 62.472 0 00-2.654-.075c-.951 0-1.342.048-1.755.1-.463.058-.942.118-1.98.118-.885 0-2.117-.044-3.764-.137-.414-.024-.776-.024-1.093-.026-.77-.001-1.778-.008-2.447-.678C2.1 12.076 2 12.636 2 13.36c0 2.544 3.092 2.517 4.753 2.565 1.52.045 2.552.062 3.303.062 1.837 0 1.99-.096 3.517-.096.75 0 1.834.023 3.613.094.173.007.404.01.67.01 1.059 0 2.655-.081 3.123-.472.868-.725 1.416-2.664.67-3.773zM3.682 10.803c.381.104.962.06 1.82.085h.038c.127.004.262.01.401.017 1.774.098 2.904.135 3.682.135 1.926 0 1.685-.217 3.736-.217.64 0 1.502.02 2.721.076.326.015 1.74.076 2.818.076.536 0 .99-.015 1.184-.06a2 2 0 00.37-.12c.385-.174.492-.437.492-.803C20.944 5.988 17.021 4 12.02 4c-2.29 0-8.96.612-8.96 5.396 0 .94.166 1.281.622 1.407z" />
            </g>
        </svg>
    )
}
